import React from 'react';
import { FileTextIcon, CpuIcon, FileCheck2Icon, ArrowRightIcon } from 'lucide-react';
const nodes = [{
  icon: FileTextIcon,
  label: 'Vous fournissez',
  sub: 'Vos informations + le prompt',
  tone: 'bg-white text-plum border-grape/20',
  iconTone: 'bg-lilac-soft text-grape'
}, {
  icon: CpuIcon,
  label: 'L’IA traite',
  sub: 'Structure + contexte + consignes',
  tone: 'bg-plum text-white border-plum',
  iconTone: 'bg-grape text-white'
}, {
  icon: FileCheck2Icon,
  label: 'Vous obtenez',
  sub: 'Une première version à relire, vérifier et adapter',
  tone: 'bg-white text-plum border-blush/30',
  iconTone: 'bg-blush-soft text-blush'
}];
export function PromptFlow() {
  return <div className="mt-8 flex flex-col items-stretch gap-3 sm:flex-row sm:items-center sm:justify-center" aria-label="Fonctionnement d'un prompt" data-id="element-240" data-mp="34j22yajousd1">
      {nodes.map((n, i) => <React.Fragment key={n.label} data-id="element-241" data-mp="1580ytgz456mw" data-mpi={i}>
          <div className={`flex items-center gap-3 rounded-2xl border px-4 py-3 sm:w-60 ${n.tone}`} data-id="element-242" data-mp="1a4izo5rbokty">
            <span className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-xl ${n.iconTone}`} data-id="element-243" data-mp="1f08mafzbttav">
              <n.icon className="h-5 w-5" data-id="element-244" data-mp="1a8qh1fq9t6k3" />
            </span>
            <div className="min-w-0" data-id="element-245" data-mp="1a77521bndho4">
              <p className="font-display text-base font-black" data-id="element-246" data-mp="1595hb33a0u6b">{n.label}</p>
              <p className="text-xs leading-snug opacity-70" data-id="element-247" data-mp="10b42iucvvh0n">{n.sub}</p>
            </div>
          </div>
          {i < nodes.length - 1 && <ArrowRightIcon className="mx-auto h-5 w-5 rotate-90 text-grape sm:mx-0 sm:rotate-0" aria-hidden="true" data-id="element-248" data-mp="1xy2puehorclv" />}
        </React.Fragment>)}
    </div>;
}